import { MapPin, MessageCircle } from "lucide-react";
import { ADDRESS, DEFAULT_WA, WHATSAPP_DISPLAY } from "../../lib/api";
import { Reveal } from "../../lib/motion";

export default function About() {
  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="relative bg-ink text-paper overflow-hidden grain py-24 lg:py-32"
    >
      <div className="absolute inset-0 ledger-bg" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <Reveal>
            <p className="text-xs uppercase tracking-[0.28em] text-crimson-bright font-semibold flex items-center gap-3">
              <span className="w-8 h-px bg-crimson-bright" /> Sobre a Contabiltec
            </p>
            <h2 className="mt-5 font-display font-extrabold tracking-tightest text-4xl md:text-6xl leading-[0.98]">
              Conte conosco para regularizar a sua{" "}
              <span className="text-crimson-bright">empresa.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-7 text-paper/70 leading-relaxed text-base md:text-lg max-w-xl">
              Na Contabiltec, nós cuidamos do processo de legalização empresarial
              para ajudar você a colocar sua empresa em dia e voltar a atuar com
              mais segurança.
            </p>
            <p className="mt-4 text-paper/70 leading-relaxed text-base md:text-lg max-w-xl">
              Nosso compromisso é simples e ambicioso: ser o melhor escritório
              contábil do estado do Amazonas — com atendimento direto com
              especialista, sem complicação e sem imposto a mais.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-9 space-y-4 border-t border-line-dark pt-8">
              <p className="flex items-start gap-3 text-paper/80">
                <MapPin size={18} className="text-crimson-bright mt-0.5 shrink-0" />
                {ADDRESS}
              </p>
              <p className="flex items-center gap-3 text-paper/80">
                <MessageCircle size={18} className="text-crimson-bright shrink-0" />
                Atendimento via WhatsApp {WHATSAPP_DISPLAY}
              </p>
            </div>
            <a
              data-testid="about-whatsapp-cta"
              href={DEFAULT_WA}
              target="_blank"
              rel="noreferrer"
              className="mt-8 inline-flex items-center gap-2 bg-crimson hover:bg-crimson-bright text-paper font-semibold px-7 py-4 rounded-full transition-all duration-300 hover:scale-[1.03]"
            >
              <MessageCircle size={18} />
              Pré-análise gratuita
            </a>
          </Reveal>
        </div>

        <Reveal delay={0.1} className="relative h-[480px] md:h-[560px] hidden md:block">
          <div className="absolute top-0 right-0 w-[72%] rotate-2 overflow-hidden border border-line-dark shadow-2xl">
            <img src="/brand/art-abertura.jpg" alt="Oferta: abra a sua empresa" className="w-full object-cover" />
          </div>
          <div className="absolute bottom-0 left-0 w-[52%] -rotate-3 overflow-hidden border border-crimson shadow-2xl">
            <img src="/brand/leao.jpg" alt="Nova reforma tributária" className="w-full object-cover" />
          </div>
          <div className="absolute top-8 left-6 bg-crimson text-paper font-display font-bold px-5 py-3 rotate-[-4deg] shadow-xl">
            Desde Manaus, para o Amazonas.
          </div>
        </Reveal>
      </div>
    </section>
  );
}
